// алиасы доменов -> нормализованное имя проекта
export const HOST_ALIASES = {
    nurlydala2: 'nurly-dala2',
    'localhost:8080': 'auezovcitypro',
    'test-shablon': 'test-theme'
}

// единый словарь проектов
export const PROJECTS = {
    'test-theme': { gtm: '', yandex: '', jivo: '', meta: { title: 'Shablon Complexes 2026', desc: '' } },
    evolution: {
        gtm: 'GTM-5PZ78B3F',
        yandex: '93535036',
        jivo: 'RFt7t7IS71',
        meta: {
            title: 'ЕVOLUTION от BAZIS-A в Астане',
            desc: 'Новый жилой комплекс рядом с ТРЦ «Хан Шатыр». 1-, 2-, 3- и 4-комнатные квартиры от 47 до 126 м2. Своя жизнь в своем городе!'
        }
    },
    'altyn-besik': {
        gtm: 'GTM-KCVGJ87',
        yandex: '94158732',
        jivo: '1ssn9WyU22',
        meta: {
            title: 'ALTYN BESIK от BAZIS-A в Астане',
            desc: 'Новый ЖК на пр. Ұлы Дала, в пяти минутах от Барыс Арены. 1-3-комнатные квартиры от 35 м2. Хорошая транспортная доступность. Развитая инфраструктура.'
        }
    },
    riviera: {
        gtm: 'GTM-PLJPMV9',
        yandex: '53066899',
        jivo: 'zUJv6meeuB',
        meta: {
            title: 'Жилой комплекс RIVIERA от BAZIS-A - это ваш дом у реки!',
            desc: 'Рядом ТРК ADK. Собственный парк на набережной с терренкуром. Детский центр развития. 1-, 2-, 3-, 4-комнатные квартиры от 40 до 120 м2.',
            keywords: 'RIVIERA, Ривьера, ,Bazis-a, BAZIS-A, Bazis, Базис, Дом у реки, ТРК АДК, ТРК ADK, Жилой комлпекс, Алматы, Almaty'
        }
    },
    auezovcity: {
        gtm: 'GTM-NDGS3KQH',
        yandex: '76923130',
        jivo: 'HDIZFNMxyb',
        meta: {
            title: 'Жилой комплекс AUEZOV CITY от BAZIS-A в Алматы',
            desc: 'Начало продаж! Для вас 1- и 2-комнатные квартиры от 41 до 75 м2 на Гоголя-Ауэзова. Хорошая транспортная доступность. Развитая инфраструктура.',
            keywords: 'ауезов сити, алматы, ауезов сити базис-а, auezov city, жк на ауэзова от базис-а, bazis-a, almaty'
        }
    },
    alfarabi27: {
        gtm: 'GTM-545XQBRW',
        yandex: '95046443',
        jivo: '9XfaXY8cgD',
        meta: {
            title: 'Al’Farabi 27 от Bazis-A. Принадлежит только вам!',
            desc: 'Новый жилой комплекс на Аль-Фараби-Сейфуллина. 2-3-4-комнатные квартиры от 50 до 153 м2. Рядом оздоровительный SPA & Fitness Center. Рассрочка 50/50.'
        }
    },
    estet: {
        gtm: 'GTM-W92BK6H3',
        yandex: '94806255',
        jivo: 'Vn3U7rNx7r',
        meta: {
            title: 'ESTET – жилой комплекс в Алматы от BAZIS-A',
            desc: 'По ул. Розыбакиева ниже пр. Аль-Фараби. Неоклассическая архитектура, огромное парковое пространство для прогулок, игр и спорта, квартиры 50–139 м2.'
        }
    },
    shahristan: {
        gtm: 'GTM-PHZXKWSS',
        yandex: '76923292',
        jivo: 'vqedFDgUHA',
        meta: {
            title: 'Жилой комплекс SHAHRISTAN от BAZIS-A в Шымкенте',
            desc: 'Начало продаж! Просторные 2- и 3-комнатные квартиры от 76 до 106 м2 в новом административно-деловом центре города. Рядом с городским акиматом'
        }
    },
    austria: {
        gtm: 'GTM-W6K55WQ',
        yandex: '76923205',
        jivo: 'XvIyiVibeU',
        meta: {
            title: 'Жилой комплекс AUSTRIA от BAZIS-A в Астане',
            desc: 'ЕВРОПА В СЕРДЦЕ АСТАНЫ',
            keywords: 'Austria, Австрия, ,Bazis-a, BAZIS-A, Bazis, Базис, Европа в центре Астаны, Жилой комлпекс, Астана, Astana'
        }
    },
    landmark: {
        gtm: 'GTM-K5RFX2J',
        yandex: '65119945',
        jivo: 'AKmftrrZ8Y',
        meta: {
            title: 'Landmark — квартал модной жизни!',
            desc: 'Жилой квартал LANDMARK расположен в ультрамодной районе Нур-Султана, вдоль бульвара Нуржол по ул. Достык. Жить здесь значит всегда быть в курсе событий, находиться в окружении модных мест притяжения, чувствовать ритм и энергию большого города. Для вас - функциональные планировки 1-, 2-, 3-, 4-комнатных квартир от 48 до 142 м2',
            keywords: 'Landmark — квартал модной жизни!, жк landmark, Astana, Nur-sultan, bazis-a, bazis, базис, landmark, астана, ,базис а, Нур-султан, лэндмарк'
        }
    },
    'orion-3': {
        gtm: 'GTM-WTBP6H6H',
        yandex: '95046448',
        jivo: 'oH8ze6t5lw',
        meta: { title: 'ORION III - жилой комплекс от BAZIS-A', desc: 'В ОКРУЖЕНИИ ПЯТИ ПАРКОВ' }
    },
    'nurly-dala2': {
        gtm: 'GTM-MLV7KJ5D',
        yandex: '95644716',
        jivo: 'i5LcEgQpfA',
        meta: {
            title: 'Жилой район NURLY DALA 2 в Алматы',
            desc: '1-, 2-, 3-комнатные квартиры от 35 до 59 м2. В шаге от дома новая школа. Хорошая транспортная доступность. Ипотека без залога. Удобная рассрочка',
            keywords: 'Nurly Dala 2, Нурлы Дала 2, Жилой район, Алматы, Almaty'
        }
    },
    satpaev: {
        gtm: 'GTM-PDRZBCZ3',
        yandex: '97096578',
        jivo: '4DIVW1Y8sI',
        meta: {
            title: 'SATPAEV – жилой комплекс от BAZIS-A в Алматы',
            desc: '1-, 2-, 3-, 4-комнатные квартиры от 47 до 84 м2 с собственной березовой рощей. Рядом с домом новая комфортная школа',
            keywords: 'Satpaev, Сатпаев ЖК, Жилой комплекс, Алматы, Almaty, Базис А, Bazis'
        }
    },
    duman: {
        gtm: 'GTM-K94VD3P6',
        yandex: '97130576',
        jivo: 'p2zPqlRVYH',
        meta: {
            title: 'DUMAN – жилой комплекс от BAZIS-A в Атырау',
            desc: 'Уютные квартиры на европейской стороне правого берега реки Урал. Рядом площадь Исатая и Махамбета. В шаге от дома - новая современная школа',
        }
    },
    noho: {
        gtm: 'GTM-M85FLVW5',
        yandex: '97328197',
        jivo: 'yebi2GsQS6',
        meta: { 
            title: 'NOHO – жилой комплекс от BAZIS-A в Астане', 
            desc: 'Просторные 1-4-комнатные квартиры от 47 до 114 м2 напротив Президентского парка. Новая комфортная школа рядом с домом' 
        }
    },
    adamant: {
        gtm: 'GTM-TMQV5C8Q',
        yandex: '97328217',
        jivo: 'GAwolmzhjD',
        meta: { 
            title: 'ADAMANT – жилой комплекс от BAZIS-A в Астане', 
            desc: '1-, 2- и 3-комнатные квартиры по пр. Мангилик ел, напротив Центральной мечети Астаны. Рядом с домом новая комфортная школа и детский сад ',
            keywords: 'Adamant, Aman, аман ЖК, Жилой комплекс, Астана, Astana, Базис А, Bazis'
        }
    },
    'riviera-plus': {
        gtm: 'GTM-5DX8GV2N',
        yandex: '97328205',
        jivo: 'sDyh3pCKDA',
        meta: { 
            title: 'RIVIERA PLUS – жилой комплекс от BAZIS-A в Алматы', 
            desc: 'Квартиры вдоль реки Большая Алматинка. Сейсмостойкие дома. Прогулочный сквер с персональным выходом на набережную. Рядом школа и детский сад',
            keywords: 'Riviera Plus, Ривьера ЖК, Ривьера плюс, Жилой комплекс, Алматы, Almaty, Базис А, Bazis'
        }
    },
    salzburg: {
        gtm: 'GTM-54569CGW',
        yandex: '97328186',
        jivo: 'U4j8QTUEBi',
        meta: { 
            title: 'SALZBURG - жилой комплекс от BAZIS-A в Астане', 
            desc: 'Впечатляющая коллекция квартир рядом с Президентским парком. Европейская архитектура. Стильный дизайн холлов до 110 м2',
            keywords: 'Salzburg, Зальсбург, Жилой комплекс, Астана, Astana, Базис А, Bazis'
        }
    },
    level: {
        gtm: 'GTM-N7MP7SJX',
        yandex: '97328221',
        jivo: 'hqryvTby1g',
        meta: { 
            title: 'LEVEL – жилой комплекс от BAZIS-A в Астане', 
            desc: '1-, 2-, 3-комнатные квартиры от 37 до 75 м2 на аллее Мынжылдык. Система контроля доступа. Face ID. Видеодомофония',
            keywords: 'Level, Левел, Жилой комплекс, Астана, Astana, Базис А, Bazis'
        }
    },
    jandostar: {
        gtm: 'GTM-NS98CP2P',
        yandex: '97328239',
        jivo: '31JfmnZ8B9',
        meta: { 
            title: 'JAN DOSTAR – жилой комплекс от BAZIS-A в Алматы', 
            desc: '1- и 2-комнатные квартиры от 36 до 66 м2 рядом с набережной реки Султанкарасу. Сейсмостойкие дома. Рядом школа и детский сад',
            keywords: 'Jan Dostar, Жандостар ЖК, Жилой комплекс, Алматы, Almaty, Базис А, Bazis'
        }
    },
    neopark: {
        gtm: 'GTM-KP8CDZT9',
        yandex: '97550558',
        jivo: 'EdvD8Uxqfz',
        meta: { 
            title: 'NEOPARK – новый жилой комплекс от BAZIS-A в Алматы', 
            desc: '1-, 2- и 3-комнатные квартиры от 37 до 84 м2 по пр. Рыскулова, рядом с Almaty Arena. В шаге от дома новая школа и детский сад',
            keywords: 'Neo Park, neopark, Неопарк ЖК, Жилой комплекс, Алматы, Almaty, Базис А, Bazis'
        }
    },
    lmgold: {
        gtm: 'GTM-PKQM8GP2',
        yandex: '99440815',
        jivo: 'eK4vpNIfU3',
        meta: {
            title: 'LANDMARK GOLD – новый жилой комплекс от BAZIS-A в Астане',
            desc: '1-, 2- и 3-комнатные квартиры по ул. улице Сыганак, вдоль бульвара Нуржол. Собственная инфраструктура, продуманное благоустройство, Community Point',
            keywords: 'LANDMARK GOLD — Золотой стандарт городской жизни!, жк landmark gold, жк landmark, Astana, Nur-sultan, bazis-a, bazis, базис, landmark gold, астана, ,базис а, Нур-султан, лэндмарк'
        }
    },
    auezovcitypro: {
        gtm: 'GTM-MDZG8HWV',
        yandex: '99776179',
        jivo: 'fHV3CtLOde',
        meta: {
            title: 'AUEZOV CITY PRO – жилой комплекс от BAZIS-A в Алматы',
            desc: '1-, 2- и 3-комнатные квартиры от 29 до 75 м2 по ул. Ауэзова, выше пр. Райымбека. Сейсмостойкие дома. Новая комфортная школа рядом с домом',
            keywords: 'ауезов сити про, алматы, ауезов сити про базис-а, auezov city pro, жк на ауэзова от базис-а, bazis-a, almaty'
            
        }
    },
    parkville: {
        gtm: 'GTM-NSTHPX53',
        yandex: '99905985',
        jivo: 'lHYtejiev1',
        meta: {
            title: 'PARKVILLE - коллекция клубных домов в Алматы',
            desc: 'Роскошные резиденции в мкр. Курамыс, южнее ул. Саина. Высокие потолки, панорамные окна, невероятные виды на собственный линейный парк и горы'
        }
    },
    grandmonaco: {
        gtm: 'GTM-PG6T6B7T',
        yandex: '100163784',
        jivo: '3tDGHLOhEA',
        meta: {
            title: 'GRAND MONACO – комплекс резиденций от BAZIS-A в Астане',
            desc: 'Престижная локация на проспекте Тауелсиздик, рядом с Президентским парком. Высокие потолки, панорамные окна, IP-домофония, электронные замки'
        }
    },
    fortis: {
        gtm: 'GTM-N52VHBFN',
        yandex: '103363495',
        jivo: 'ePcUF05fxH',
        meta: {
            title: 'FORTIS – жилой комплекс от BAZIS-A в Астане',
            desc: '1-, 2- и 3-комнатные квартиры от 39 до 78 м2 в шаге от БАРЫС АРЕНА. Рядом школы, детские сады, спортивные центры'
        }
    },
    summit: {
        gtm: 'GTM-KWX3N5WQ',
        yandex: '103735607',
        jivo: 'KJC7abS3xr',
        meta: { 
            title: 'SUMMIT - жилой комплекс от BAZIS-A в Шымкенте', 
            desc: 'Квартиры рядом с ТРЦ Hyper House. Школы и детские сады рядом с домом. Двор-парк с ландшафтным дизайном. Авторские холлы. Подземный паркинг' 
        }
    },
    cascade: {
        gtm: 'GTM-5KTPB5ZF',
        yandex: '103585542',
        jivo: 'nUBXWLbSmI',
        meta: { 
            title: 'CASCADE – жилой комплекс от BAZIS-A в Астане', 
            desc: 'Уютные квартиры рядом с аллеей Мынжылдык. Новая комфортная школа рядом с домом. Зеленый двор на стилобате. Продуманные планировочные решения' 
        }
    },
    tribeca: { 
        gtm: 'GTM-PJHKQP8H', 
        yandex: '104375323', 
        jivo: 'aZoOJxg21H', 
        meta: { 
            title: 'TRIBECA – новый жилой комплекс от BAZIS-A в Астане', 
            desc: 'Просторные 1-4-комнатные квартиры от 48 до 120 м2 рядом с Президентским парком. В шаге от дома новая комфортная школа' 
        } 
    },
    'adamant-plus': {
        gtm: 'GTM-MMZ33SHF',
        yandex: '103560074',
        jivo: 'PGnMGSYVRH',
        meta: { 
            title: 'ADAMANT PLUS – жилой комплекс от BAZIS-A', 
            desc: 'Квартиры с видом на центральную мечеть. Рядом новая школа и детский сад. Свой двор-парк с фруктовым садом и арт-объектами. Авторские холлы 138 м²' 
        }
    },
    elios: { 
        gtm: 'GTM-NF9BKTQS', 
        yandex: '104763433', 
        jivo: '5D54IclPZ3', 
        meta: { 
            title: 'ELIOS – новый жилой комплекс от BAZIS-A в Астане', 
            desc: 'Квартиры от 40 до 81 м2 на аллее Мынжылдык. Авторские холлы. Зеленый car-free-двор с ландшафтным дизайном. Рядом с домом школы и детские сады' 
        } 
    },
    horizon: { 
        gtm: 'GTM-PM98FSWB', 
        yandex: '106252375', 
        jivo: 'tLzJ3MxZvi', 
        meta: { 
            title: 'HORIZON - жилой комплекс от BAZIS-A в Астане ', 
            desc: 'Уютные 1-, 2- и 3-комнатные квартиры в шаге от «Барыс Арена». Зеленый двор с детскими площадками. Рядом несколько школ и детских садов' 
        } 
    },
    alta: { 
        gtm: 'GTM-5WWQ3NM3', 
        yandex: '106271761', 
        jivo: 'PZWkulsL6u', 
        meta: { 
            title: 'ALTA – жилой комплекс от BAZIS-A в Алматы', 
            desc: 'Квартиры на пр. Райымбека уг. ул. Саина. Продуманные планировочные решения. Сейсмостойкость домов 9 баллов. Рядом школа и детский сад' 
        } 
    },
    alter: { 
        gtm: 'GTM-M7RDMQG3', 
        yandex: '', 
        jivo: '2c00A1eMNS', 
        meta: { 
            title: 'ALTER - жилой комплекс от BAZIS-A на аллее Мынжылдык в Астане', 
            desc: '1-, 2-, 3-комнатные квартиры от 35 до 87 м2 по пр. Жумабаева, вдоль аллеи Мынжылдык, в нескольких минутах от площади Независимости. Рядом школа-гимназия №83' 
        } 
    },
    maverick: { 
        gtm: '', 
        yandex: '', 
        jivo: '', 
        meta: { 
            title: 'MAVERICK – жилой комплекс от BAZIS-A в Алматы', 
            desc: '' 
        } 
    },
    aston: {
        gtm: 'GTM-53S34G4K',
        yandex: '103590710',
        jivo: 'paSCBe2aUd',
        meta: { 
            title: 'ASTON – жилой комплекс от BAZIS-A в Астане', 
            desc: 'Квартиры рядом с рекой Есиль. Зеленый car-free-двор с ландшафтным дизайном. Стильные холлы. Продуманные планировочные решения' 
        }
    },
    aspen: { 
        gtm: 'GTM-5PN2GTKJ', 
        yandex: '', 
        jivo: 'pqSoJRicuW', 
        meta: { 
            title: 'ASPEN – новый жилой комплекс от BAZIS-A в Астане', 
            desc: '1-2-3-комнатные квартиры от 36 до 74 м² по пр. Улы Дала. Зеленый двор с ландшафтным дизайном. Стильные холлы. Продуманные планировочные решения' 
        } 
    },
    taulan: { 
        gtm: 'GTM-N7TRCNS6', 
        yandex: '', 
        jivo: 'Y3zmV6h6mF', 
        meta: { 
            title: 'TAULAN - новый жилой комплекс от BAZIS-A в Алматы', 
            desc: '1-, 2- и 3-комнатные квартиры от 38 до 76 м2 по ул. Ауэзова, ниже ул. Гоголя. Сейсмостойкость домов 9 баллов. Новая комфортная школа рядом с домом'
        } 
    },
    manific: { gtm: 'GTM-KBVC9TJR', yandex: '', jivo: '', meta: { title: 'MANIFIC', desc: '' } },
    vista: { gtm: '', yandex: '', jivo: '', meta: { title: 'Vista Demo', desc: '' } },
    astonpark: { gtm: '', yandex: '', jivo: '', meta: { title: 'AstonPark Demo', desc: '' } },
    kayrat: { gtm: '', yandex: '', jivo: '', meta: { title: 'Kayrat Demo', desc: '' } },
    amandyq: { gtm: '', yandex: '', jivo: '', meta: { title: 'Amandyq Demo', desc: '' } }
}

export function resolveProjectKey(rawHost) {
    const host = (rawHost || '').trim().toLowerCase();  

    // 1) проверяем прямой алиас (например localhost:8080)
    if (HOST_ALIASES[host]) {
        const mapped = HOST_ALIASES[host];
        return PROJECTS[mapped] ? mapped : 'setup-theme';
    }

    // hostname без порта
    const hostname = host.split(':')[0]; // evolution.bazis.kz
    const sub = hostname.split('.')[0];  // evolution

    // 2) hostname как алиас
    if (HOST_ALIASES[hostname]) {
        const mapped = HOST_ALIASES[hostname];
        return PROJECTS[mapped] ? mapped : 'setup-theme';
    }

    // 2.1) subdomain как алиас
    if (HOST_ALIASES[sub]) {
        const mapped = HOST_ALIASES[sub];
        return PROJECTS[mapped] ? mapped : 'setup-theme';
    }

    // 3) прямое совпадение subdomain с PROJECTS
    if (PROJECTS[sub]) {
        return sub;
    }

    // 4) fallback
    return 'setup-theme';
}
